import React, { useState, useCallback, Fragment, useEffect, } from "react";
import { ChromePicker } from "react-color";
import { FormControl } from "react-bootstrap";
import { useFormContext } from "./Form";
import { observer } from "mobx-react-lite";
import { withFormWrapper, DEFAULT_ID, emptyStringIfNull, } from "./withFormWrapper";
import { keyPress } from "./utils/keyPress";
import { StaticInputValue } from "./StaticInput";
export const RawColourPicker = observer(({ name, disabled, onChange, uniqueId = DEFAULT_ID, label, staticFormatter, dataId, dataLabel, dataTestId, }) => {
    const { values, formDisabled, isStatic } = useFormContext();
    const [showPicker, setShowPicker] = useState(false);
    const handlePickerChange = useCallback(({ hex }) => {
        onChangeSetValue(onChange, hex, values, name);
    }, [onChange, name, values]);
    const handleChange = React.useCallback((e) => {
        onChangeSetValue(onChange, e.target.value, values, name);
    }, [onChange, values, name]);
    const keyFunctions = useCallback((event) => {
        if (event.keyCode === keyPress.ESCAPE ||
            event.keyCode === keyPress.ENTER) {
            setShowPicker(false);
        }
        if (event.keyCode === keyPress.BACKSPACE ||
            event.keyCode === keyPress.DELETE) {
            values.set(name, "");
        }
    }, [values, name]);
    useEffect(() => {
        if (showPicker) {
            document.addEventListener("keydown", keyFunctions, false);
        }
        return () => {
            if (showPicker) {
                document.removeEventListener("keydown", keyFunctions, false);
            }
        };
    }, [showPicker, keyFunctions]);
    if (isStatic) {
        return (React.createElement(StaticInputValue, { label: label, name: name, staticFormatter: staticFormatter, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    return (React.createElement(Fragment, null,
        React.createElement(FormControl, { name: name, value: emptyStringIfNull(values.get(name)), disabled: disabled || formDisabled, onSelect: () => setShowPicker(!disabled), id: `form-group-${name}-${uniqueId}`, onChange: handleChange }),
        showPicker ? (React.createElement("div", { style: { position: "absolute", zIndex: 1051 } },
            React.createElement("div", { style: {
                    position: "fixed",
                    top: "0px",
                    right: "0px",
                    bottom: "0px",
                    left: "0px",
                }, onClick: () => setShowPicker(false) }),
            React.createElement(ChromePicker, { color: values.get(name) ?? "", onChange: handlePickerChange }))) : null));
});
export const ColourPicker = withFormWrapper({
    WrappedComponent: RawColourPicker,
});
function onChangeSetValue(onChange, newValue, values, name) {
    if (onChange) {
        onChange(newValue, values.get(name));
    }
    values.set(name, newValue);
}
